import { BaseIcon } from '../base-icon'
import { IconProps } from '../icons.props'

export const StarsIcon = ({ color, size = 24, ...props }: IconProps<24>) => (
  <BaseIcon {...props} color={color} height={size} width={size}>
    <g clipPath="url(#clip0_2834_18772)">
      <path
        d="M8.8132 15.9038L8 18.75L7.1868 15.9038C6.75968 14.4089 5.59112 13.2403 4.09619 12.8132L1.25 12L4.09619 11.1868C5.59113 10.7597 6.75968 9.59112 7.1868 8.09619L8 5.25L8.8132 8.09619C9.24032 9.59113 10.4089 10.7597 11.9038 11.1868L14.75 12L11.9038 12.8132C10.4089 13.2403 9.24032 14.4089 8.8132 15.9038Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2479"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2589 8.71454L17 9.75L16.7411 8.71454C16.4388 7.50533 15.4947 6.56117 14.2855 6.25887L13.25 6L14.2855 5.74113C15.4947 5.43883 16.4388 4.49467 16.7411 3.28546L17 2.25L17.2589 3.28546C17.5612 4.49467 18.5053 5.43883 19.7145 5.74113L20.75 6L19.7145 6.25887C18.5053 6.56117 17.5612 7.50532 17.2589 8.71454Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2479"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8942 20.5673L15.5 21.75L15.1058 20.5673C14.8818 19.8954 14.3546 19.3682 13.6827 19.1442L12.5 18.75L13.6827 18.3558C14.3546 18.1318 14.8818 17.6046 15.1058 16.9327L15.5 15.75L15.8942 16.9327C16.1182 17.6046 16.6454 18.1318 17.3173 18.3558L18.5 18.75L17.3173 19.1442C16.6454 19.3682 16.1182 19.8954 15.8942 20.5673Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2479"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2834_18772">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </BaseIcon>
)
